import React from 'react';
import CheckRow from './CheckRow';
import suitcase from '../../assets/suitcase.svg';
import './ReadinessLoading.scss';

const DAZN_LOGO_URL = 'https://cdn.upshow.tv/ui-assets/DAZNForBusiness-Inline-White.png';
const DAZN_INIT_LOGO_URL = 'https://cdn.upshow.tv/ui-assets/DAZN-ForBusiness-Grey.png';

// ponytail: cosmetic intro delay — tune freely, bootOverlay.js imports this to sync check start
export const INTRO_MS = 2000;

const DISPLAY_LABELS = {
  drmLicenseReachability: 'Verifying DRM License Reachability',
  manifestCdnAccess:      'Checking Manifest / CDN Access',
  connectionSpeed:        'Checking your Connection Speed',
  connectionQuality:      'Checking your Connection Quality',
  portDomainReachability: 'Checking Port / Domain Reachability',
  socketReachability:     'Checking WebSocket Server Reachability',
};

export default function ReadinessLoading({ checks, ready }) {
  if (!ready) {
    return (
      <div className="RkLoading RkLoading--init" role="status" aria-live="polite" aria-label="Running streaming diagnostics">
        <img className="RkLoading__init-logo" src={DAZN_INIT_LOGO_URL} alt="DAZN For Business" />
        <p className="RkLoading__init-label">Initializing diagnosis…</p>
      </div>
    );
  }

  return (
    <div className="RkLoading" role="status" aria-live="polite" aria-label="Running streaming diagnostics">
      <div className="RkLoading__left">
        <div className="RkLoading__top">
          <p className="RkLoading__eyebrow">
            <img className="RkLoading__eyebrow-icon" src={suitcase} alt="" />
            Streaming Diagnostic
          </p>
          <h1 className="RkLoading__headline">Checking your System</h1>
          <p className="RkLoading__subtitle">This should only take a few seconds.</p>
        </div>
        <img className="RkLoading__logo" src={DAZN_LOGO_URL} alt="DAZN For Business" />
      </div>
      <div className="RkLoading__right">
        <div className="RkLoading__card">
          <ul className="RkLoading__list">
            {checks.map((check) => (
              <CheckRow
                key={check.id}
                check={{ ...check, label: DISPLAY_LABELS[check.id] || check.label }}
                variant="loading"
              />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
